"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["children", "className", "href", "inverted", "soft", "top"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Link = function Link(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? "#" : _ref$href,
      _ref$inverted = _ref.inverted,
      inverted = _ref$inverted === void 0 ? false : _ref$inverted,
      _ref$soft = _ref.soft,
      soft = _ref$soft === void 0 ? false : _ref$soft,
      _ref$top = _ref.top,
      top = _ref$top === void 0 ? false : _ref$top,
      props = _objectWithoutProperties(_ref, _excluded);

  var link = /*#__PURE__*/_react.default.createElement("a", _extends({
    className: (0, _classnames.default)(className, {
      "p-link--inverted": inverted,
      "p-link--soft": soft,
      "p-top__link": top
    }),
    href: href
  }, props), children);

  if (top) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "p-top"
    }, link);
  }

  return link;
};

var _default = Link;
exports.default = _default;